import { AsyncPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, inject, input } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';
import { DxListModule } from 'devextreme-angular/ui/list';
import { Observable, map } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { RuntimeConfigService } from 'src/app/core/services/runtime-config.service';

@Component({
    selector: 'app-user-panel',
    templateUrl: 'user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    standalone: true,
    imports: [DxListModule, DxContextMenuModule, DxDropDownButtonModule, DxButtonModule, AsyncPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserPanelComponent {
    private readonly authService = inject(AuthService);
    private readonly runtimeConfigService = inject(RuntimeConfigService);
    private readonly translocoService = inject(TranslocoService);

    menuItems = input.required<any[]>({});

    readonly isSalesforceAuth = this.runtimeConfigService.isSalesforceAuth();
    readonly logoutLabel = this.translocoService.translate('logout');

    /** Single slot for Salesforce account-switch panel (email + logout live in the template). */
    readonly salesforceMenuItems = [{ id: 'account-switch', text: '' }];

    currentUser$ = this.authService.currentUser$;

    logout(event?: Event): void {
        event?.stopPropagation();
        this.authService.logout();
    }
    userInitials$ = this.currentUser$.pipe(
        map(user => {
            const fullName = user?.displayName || user?.firstName + ' ' + user?.familyName || '';
            if (!fullName) return 'U';
            const names = fullName.split(' ').filter(Boolean);
            if (names.length >= 2) {
                return (names[0][0] + names[1][0]).toUpperCase();
            }
            return fullName[0]?.toUpperCase() || 'U';
        })
    );

    avatarUrl$: Observable<string | undefined> = this.currentUser$.pipe(map(user => user?.avatarUrl ?? undefined)) as unknown as Observable<
        string | undefined
    >;
}
